import React, { ReactElement } from "react";

import Link from "next/link";

import { Nav, Brand, LogoContainer, LogoText, NavButtonsContainer, NavButtonText, ActionButton, Title } from "./styles";

import BurgerMenu from "~/components/BurgerMenu";
import * as Logos from "~/components/icons/Logo";
import useWindowSize from "~/hooks/useWindowSize";

interface NavbarProps {
  inverted?: boolean;
  navBarForSearchPage?: boolean;
}

export default function Navbar({ inverted = false, navBarForSearchPage = false }: NavbarProps) {
  const size = useWindowSize();

  const itemsToShowBurgerMenuNetworkPage: ReactElement[] = [
    <Link key={0} href="/network/search" passHref>
      <NavButtonText>Search</NavButtonText>
    </Link>,
    <Link key={1} href="/auth?redirect=/dashboard/outgoing" passHref>
      <NavButtonText>Log in</NavButtonText>
    </Link>,
  ];

  const itemsToShowBurgerMenuSearchPage: ReactElement[] = [
    <Link key={0} href="/auth/get-started" passHref>
      <ActionButton>
        <Title>JOIN FOR FREE TODAY</Title>
      </ActionButton>
    </Link>,
  ];

  return (
    <Nav>
      {size.width <= 540 && (
        <BurgerMenu
          itemsToShowOnBurgerMenu={
            navBarForSearchPage ? itemsToShowBurgerMenuSearchPage : itemsToShowBurgerMenuNetworkPage
          }
        />
      )}

      <Brand>
        <a href="https://notabene.id" target="_blank" rel="noreferrer">
          <LogoContainer inverted={inverted}>
            <Logos.Logo style={{ width: "100%", height: "100%" }} />
          </LogoContainer>
        </a>
        {size.width > 540 && (
          <Link href="/network" passHref replace>
            <LogoText>VASP & Crypto companies network</LogoText>
          </Link>
        )}
      </Brand>

      {size.width > 540 && navButtons(navBarForSearchPage)}
    </Nav>
  );
}

function navButtons(navBarForSearchPage: boolean) {
  if (navBarForSearchPage) {
    return <NavBarForSearchPage />;
  }
  return <NavBarForNetworkPage />;
}

function NavBarForNetworkPage() {
  return (
    <NavButtonsContainer>
      <Link href="/network/search" passHref>
        <NavButtonText>Search</NavButtonText>
      </Link>
      <Link href="/auth?redirect=/dashboard/outgoing" passHref>
        <NavButtonText>Log in</NavButtonText>
      </Link>
    </NavButtonsContainer>
  );
}

function NavBarForSearchPage() {
  return (
    <NavButtonsContainer>
      <Link href="/auth/get-started" passHref>
        <ActionButton>
          <Title>JOIN FOR FREE TODAY</Title>
        </ActionButton>
      </Link>
    </NavButtonsContainer>
  );
}
